import LegacyExperience from './CobraGeneralInformation.legacy';
import { versioned } from '../versioning/RenewalExperience';
// CobraGeneralInformation.js

import React, { useState, useEffect, useCallback, forwardRef, useImperativeHandle } from 'react';
import { Form, Card, Row, Col, FormControl, OverlayTrigger, Tooltip } from 'react-bootstrap';
import axios from 'axios';
import debounce from 'lodash/debounce';
import Select from 'react-select';
import config from '../config';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const CobraGeneralInformation = forwardRef(({ caseId, renewalCase, isDisableForUsers, onError = () => { } }, ref) => {
    const fetchUrl = `${config.API_URL}/CobraGeneralInformations/ByCaseId/${caseId}`;
    const updateUrl = `${config.API_URL}/CobraGeneralInformations`;

    

    const [generalInfo, setGeneralInfo] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [validationErrors, setValidationErrors] = useState({});

    useEffect(() => {
        fetchGeneralInfo();
    }, [caseId]);

    

    const qbNpmFileSource = generalInfo?.qbNpmFileSource;

    const fetchGeneralInfo = async () => {
        try {
            const response = await axios.get(fetchUrl);
            setGeneralInfo(response.data || null);
        } catch (error) {
            setError('Error fetching plans.');
        } finally {
            setLoading(false);
        }
    };

    const debouncedUpdate = useCallback(
        debounce(async (updatedFields) => {
            
                try {
                    const patchDocument = Object.keys(updatedFields).map(key => ({
                        path: `/${key}`,
                        value: updatedFields[key]
                    }));
                    await axios.patch(`${updateUrl}/${generalInfo?.id}`, patchDocument);
                } catch (error) {
                    console.error('Error updating plan:', error);
                    onError(error);
                }
            
        }, 500),
        [updateUrl, onError, validationErrors, caseId]
    );
    

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        validateField(name, value);
        setGeneralInfo(prevInfo => {
            const updatedInfo = { ...prevInfo, [name]: value };
            debouncedUpdate({ [name]: value });
            return updatedInfo;
        });
    };
    
    const handleSelectChange = (selectedOption, { name }) => {
        const value = selectedOption ? selectedOption.value : '';
        validateField(name, value);
        setGeneralInfo(prevInfo => {
            const updatedInfo = { ...prevInfo, [name]: value };
            debouncedUpdate({ [name]: value });
            return updatedInfo;
        });
    };
    
    const handleToggleChange = (e, property) => {
        const { checked } = e.target;
        const value = checked ? 'true' : 'false';
        setGeneralInfo(prevInfo => {
            const updatedInfo = { ...prevInfo, [property]: value };
            debouncedUpdate({ [property]: value });
            return updatedInfo;
        });
    };
    

    const validateField = (name, value) => {
        let errors = { ...validationErrors };

        switch (name) {
            // case 'vendorContactEmail':
            //     if (generalInfo.clarityEventReceiptionMethod?.includes('Clarity Comprehensive API') && !value.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
            //         errors[name] = 'Please enter a valid email address.';
            //     } else {
            //         delete errors[name];
            //     }
            //     break;
            // case 'vendorName':
            //     if (generalInfo.clarityEventReceiptionMethod?.includes('Clarity Comprehensive API') && !value) {
            //         errors[name] = 'Vendor name is required';
            //     } else {
            //         delete errors[name];
            //     }
            //     break;
            case 'currentBenefitAdministrationPlatform':
                if (
                    qbNpmFileSource === "Manual Entry" ||
                    qbNpmFileSource === "Client Direct EDI" ||
                    qbNpmFileSource === "UNKNOWN" ||
                    qbNpmFileSource === null
                ) {
                    if ( !value) {
                        errors[name] = 'This field is required';
                    } else {
                        delete errors[name];
                    }
                    break;
                }
                case 'currentPayrollPlatform':
                if (
                    qbNpmFileSource === "Manual Entry" ||
                    qbNpmFileSource === "Client Direct EDI" ||
                    qbNpmFileSource === "UNKNOWN" ||
                    qbNpmFileSource === null
                ) {
                    if ( !value) {
                        errors[name] = 'This field is required';
                    } else {
                        delete errors[name];
                    }
                    break;
                }
            case 'otherBenefitAdminPlatform':
                if (generalInfo.currentBenefitAdministrationPlatform === 'Other' && generalInfo?.[name.replace('other', 'current')] === 'Other' && !value) {
                    errors[name] = 'Please specify the platform name.';
                } else {
                    delete errors[name];
                }
                break;
                case 'otherPayrollPlatform':
                if (generalInfo.currentPayrollPlatform === 'Other' && generalInfo?.[name.replace('other', 'current')] === 'Other' && !value) {
                    errors[name] = 'Please specify the platform name.';
                } else {
                    delete errors[name];
                }
                break;
            default:
                break;
        }

        setValidationErrors(errors);
    };

    

    // Define validateAll function
    const validateAll = () => {
        let errors = {};

        
        if (generalInfo?.isChange === 'true') {
            const clarityMethod = generalInfo.clarityEventReceiptionMethod;
            if (!clarityMethod) {
                errors.clarityEventReceiptionMethod = 'This field is required.';
            }

            // if (clarityMethod?.includes('Clarity Comprehensive API')) {
            //     if (!generalInfo.vendorName) {
            //         errors.vendorName = 'Vendor Name is required.';
            //     }
                
            //     if (!generalInfo.vendorContactEmail || !generalInfo.vendorContactEmail.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
            //         errors.vendorContactEmail = 'Please enter a valid email address.';
            //     }
            // }
        }

        
        if (
            qbNpmFileSource === "Manual Entry" ||
            qbNpmFileSource === "Client Direct EDI" ||
            qbNpmFileSource === "UNKNOWN" ||
            qbNpmFileSource === null
        ) {
            if (!generalInfo.currentBenefitAdministrationPlatform) {
                errors.currentBenefitAdministrationPlatform = 'This field is required.';
            }
            if (generalInfo.currentBenefitAdministrationPlatform === 'Other' && !generalInfo.otherBenefitAdminPlatform) {
                errors.otherBenefitAdminPlatform = 'Please specify the platform name.';
            }

            if (!generalInfo.currentPayrollPlatform) {
                errors.currentPayrollPlatform = 'This field is required.';
            }
            if (generalInfo.currentPayrollPlatform === 'Other' && !generalInfo.otherPayrollPlatform) {
                errors.otherPayrollPlatform = 'Please specify the platform name.';
            }
        }

        setValidationErrors(errors);

        // Return true if no errors
        return Object.keys(errors).length === 0;
    };

    // Expose validateAll via ref
    useImperativeHandle(ref, () => ({
        validateAll,
        getFormData: () => generalInfo, // Optional: expose form data if needed
    }));

    const customStyles = (hasError) => ({
        control: (provided) => ({
            ...provided,
            borderColor: hasError ? '#dc3545' : provided.borderColor,
            '&:hover': {
                borderColor: hasError ? '#dc3545' : provided.borderColor,
            },
            boxShadow: hasError ? '0 0 10px rgba(220, 53, 69, 0.5)' : provided.boxShadow,
        }),
    });


    if (loading) return <Skeleton count={5} />;
    if (error) return <p>{error}</p>;

    const clarityOptions = [
        { value: 'Client/Broker will manually enter into the COBRA platform', label: 'Client/Broker will manually enter into the COBRA platform' },
        { value: 'Client/Broker will provide ongoing files for import into the COBRA platform', label: 'Client/Broker will provide ongoing files for import into the COBRA platform' },
        { value: 'Marketplace connection with Ease', label: 'Marketplace connection with Ease' },
        { value: 'Marketplace connection with Employee Navigator', label: 'Marketplace connection with Employee Navigator' },
        { value: 'Clarity Comprehensive API', label: 'Clarity Comprehensive API' },
    ];

    const platformOptions = [
        { value: "ADP", label: "ADP" },
        { value: "Asure", label: "Asure" },
        { value: "Bamboo HR", label: "Bamboo HR" },
        { value: "Benroll", label: "Benroll" },
        { value: "Ceridian", label: "Ceridian" },
        { value: "Dayforce", label: "Dayforce" },
        { value: "Ease", label: "Ease" },
        { value: "Emplova", label: "Emplova" },
        { value: "Engage PEO", label: "Engage PEO" },
        { value: "Execupay", label: "Execupay" },
        { value: "Extensis", label: "Extensis" },
        { value: "EXTENSISHR", label: "EXTENSISHR" },
        { value: "Frank Crum", label: "Frank Crum" },
        { value: "Fusion Employer Services LLC", label: "Fusion Employer Services LLC" },
        { value: "GoCo", label: "GoCo" },
        { value: "GovCon Pay iSolved", label: "GovCon Pay iSolved" },
        { value: "Gusto", label: "Gusto" },
        { value: "HRP", label: "HRP" },
        { value: "INOVA", label: "INOVA" },
        { value: "Integrated Payroll Systems Inc", label: "Integrated Payroll Systems Inc" },
        { value: "iSolve", label: "iSolve" },
        { value: "iSolved (PNIHCM)", label: "iSolved (PNIHCM)" },
        { value: "Iuvosystems", label: "Iuvosystems" },
        { value: "Justworks", label: "Justworks" },
        { value: "Kelly Benefits", label: "Kelly Benefits" },
        { value: "Namely", label: "Namely" },
        { value: "One Source", label: "One Source" },
        { value: "OneDigi", label: "OneDigi" },
        { value: "Paychex", label: "Paychex" },
        { value: "Paycom", label: "Paycom" },
        { value: "Paycor", label: "Paycor" },
        { value: "Payday", label: "Payday" },
        { value: "PayEntry", label: "PayEntry" },
        { value: "Payroll Analyst II Talent Solutions HR Payroll and Systems", label: "Payroll Analyst II Talent Solutions HR Payroll and Systems" },
        { value: "Payroll Dynamics", label: "Payroll Dynamics" },
        { value: "Paylocity", label: "Paylocity" },
        { value: "Payroll Systems", label: "Payroll Systems" },
        { value: "Payserve", label: "Payserve" },
        { value: "Plan Source", label: "Plan Source" },
        { value: "PNI", label: "PNI" },
        { value: "PNI HCM", label: "PNI HCM" },
        { value: "PNI HCM GovConPay", label: "PNI HCM GovConPay" },
        { value: "Prestige PEO", label: "Prestige PEO" },
        { value: "Prime Pay", label: "Prime Pay" },
        { value: "Prime Point", label: "Prime Point" },
        { value: "PrimePoint", label: "PrimePoint" },
        { value: "Rippling", label: "Rippling" },
        { value: "SDP", label: "SDP" },
        { value: "Selerix", label: "Selerix" },
        { value: "Staffpro", label: "Staffpro" },
        { value: "Steve Dawes CP", label: "Steve Dawes CP" },
        { value: "UKG", label: "UKG" },
        { value: "Ultimate Software", label: "Ultimate Software" },
        { value: "Viventium", label: "Viventium" },
        { value: "Workday", label: "Workday" },
        { value: "Wurk", label: "Wurk" },
        { value: "Other", label: "Other" }
    ];
    

    const payrollPlatformOptions = [
        { value: 'GoCo', label: 'GoCo' },
        { value: 'Namely', label: 'Namely' },
        { value: 'One Source', label: 'One Source' },
        { value: 'Paycom', label: 'Paycom' },
        { value: 'Paycor', label: 'Paycor' },
        { value: 'Payday', label: 'Payday' },
        { value: 'Paylocity', label: 'Paylocity' },
        { value: 'Plan Source', label: 'Plan Source' },
        { value: 'PrimePay', label: 'PrimePay' },
        { value: 'Ultimate Software', label: 'Ultimate Software' },
        { value: 'Workday', label: 'Workday' },
        { value: 'Other', label: 'Other' },
    ];

    //const isDisabled = renewalCase?.cobraSubmissionStatus === 'Submitted' || isDisableForUsers;
    const isDisabled = isDisableForUsers;

    return (
        <Col lg={12} className="mb-3">
    <Card>
        <Card.Body>
            <Card.Title>General Information </Card.Title>

            <Form>
                <Form.Group as={Row} className="mb-2">
                    <Col lg={12}>
                        <div className="form-check form-switch form-toggle">
                        <label className="form-check-label">
    Clarity currently receives your company’s new qualifying events and newly eligible participants via{" "}
    {renewalCase?.qbnpmIntegrationType &&
     renewalCase?.qbnpmIntegrationType.trim() !== "" &&
     renewalCase?.qbnpmIntegrationType.trim().toUpperCase() !== "N/A" ? (
        <strong>
            {renewalCase?.qbnpmIntegrationType} from {qbNpmFileSource}
        </strong>
    ) : (
        <strong>{qbNpmFileSource}</strong>
    )}
    . Is this changing?
</label>
                            <input
                                type="checkbox"
                                className="form-check-input form-check-input-toggel toggle-input-switch"
                                role="switch"
                                checked={generalInfo?.isChange === 'true'}
                                onChange={(e) => handleToggleChange(e, 'isChange')}
                                disabled={isDisabled}
                            />
                        </div>
                    </Col>
                </Form.Group>

                {generalInfo?.isChange === 'true' && (
                    <>
                        <Form.Group as={Row} className="mb-2">
                            <Form.Label column lg={6}>
                                How will Clarity receive new qualifying events and newly eligible participants for the required notices?
                            </Form.Label>
                            
                            <Col lg={6}>
                                <Select
                                    name="clarityEventReceiptionMethod"
                                    options={clarityOptions}
                                    value={clarityOptions.find(option => option.value === generalInfo?.clarityEventReceiptionMethod)}
                                    onChange={handleSelectChange}
                                    styles={customStyles(validationErrors && validationErrors.clarityEventReceiptionMethod)}
                                    isDisabled={isDisabled}
                                />
                                {validationErrors.clarityEventReceiptionMethod && (
                                    <div className="invalid-feedback d-block">
                                        {validationErrors.clarityEventReceiptionMethod}
                                    </div>
                                )}
                            </Col>
                        </Form.Group>

                        {generalInfo?.clarityEventReceiptionMethod?.includes('Clarity Comprehensive API') && (
                            <Row className="mb-2">
                                
                                <em>API Terms &amp; Conditions - Electronic Acceptance: By selecting “Clarity Comprehensive API” above and 
                                    completing this renewal, you confirm that you (the “Client") have read and accept the 
                                    <a href='https://kits.claritybenefitsolutions.com/api-integration-terms-and-conditions/' target='_blank'>
                                    API Integration Terms and Conditions
                                    </a> 
                                    and are duly authorized to bind the Client identified above. Your electronic acceptance and related electronic 
                                    records have the same legal effect as a signed writing under applicable law. The Client’s continued use of the 
                                    API Integration services also constitute acceptance of those terms.</em>
                            </Row>
                        )}
                    </>
                )}

                {(qbNpmFileSource === "Manual Entry" ||
                    qbNpmFileSource === "Client Direct EDI" ||
                    qbNpmFileSource === "UNKNOWN" ||
                    qbNpmFileSource === null) && (
                        <>
                            <Form.Group as={Row} className="mb-2">
                                <Form.Label column lg={4}>
                                    What is your current benefit administration platform?
                                </Form.Label>
                                <Col lg={3}>
                                    <Select
                                        name="currentBenefitAdministrationPlatform"
                                        options={platformOptions}
                                        value={platformOptions.find(option => option.value === generalInfo?.currentBenefitAdministrationPlatform)}
                                        onChange={handleSelectChange}
                                        styles={customStyles(validationErrors && validationErrors.currentBenefitAdministrationPlatform)}
                                        isDisabled={isDisabled}
                                    />
                                    {validationErrors.currentBenefitAdministrationPlatform && (
                                        <div className="invalid-feedback d-block">
                                            {validationErrors.currentBenefitAdministrationPlatform}
                                        </div>
                                    )}
                                    {generalInfo?.currentBenefitAdministrationPlatform === 'Other' && (
                                        <>
                                            <FormControl
                                                className="mt-1"
                                                placeholder="Other"
                                                name="otherBenefitAdminPlatform"
                                                value={generalInfo?.otherBenefitAdminPlatform || ''}
                                                onChange={handleInputChange}
                                                isInvalid={!!validationErrors.otherBenefitAdminPlatform}
                                                disabled={isDisabled}
                                            />
                                            {validationErrors.otherBenefitAdminPlatform && (
                                                <Form.Control.Feedback type="invalid">
                                                    {validationErrors.otherBenefitAdminPlatform}
                                                </Form.Control.Feedback>
                                            )}
                                        </>
                                    )}
                                </Col>
                            </Form.Group>

                            {/* <Form.Group as={Row} className="mb-2">
                                <Form.Label column lg={4}>
                                    What is your current payroll platform?
                                </Form.Label>
                                <Col lg={3}>
                                    <Select
                                        name="currentPayrollPlatform"
                                        options={payrollPlatformOptions}
                                        value={payrollPlatformOptions.find(option => option.value === generalInfo?.currentPayrollPlatform)}
                                        onChange={handleSelectChange}
                                        styles={customStyles(validationErrors && validationErrors.currentPayrollPlatform)}
                                        isDisabled={isDisabled}
                                    />
                                    {validationErrors.currentPayrollPlatform && (
                                        <div className="invalid-feedback d-block">
                                            {validationErrors.currentPayrollPlatform}
                                        </div>
                                    )}
                                    {generalInfo?.currentPayrollPlatform === 'Other' && (
                                        <>
                                            <FormControl
                                                className="mt-1"
                                                placeholder="Other"
                                                name="otherPayrollPlatform"
                                                value={generalInfo?.otherPayrollPlatform || ''}
                                                onChange={handleInputChange}
                                                isInvalid={!!validationErrors.otherPayrollPlatform}
                                                disabled={isDisabled}
                                            />
                                            {validationErrors.otherPayrollPlatform && (
                                                <Form.Control.Feedback type="invalid">
                                                    {validationErrors.otherPayrollPlatform}
                                                </Form.Control.Feedback>
                                            )}
                                        </>
                                    )}
                                </Col>
                            </Form.Group> */}
                        </>
                    )}
            </Form>
        </Card.Body>
    </Card>
</Col>

    );
});

export default versioned(CobraGeneralInformation, LegacyExperience);
